import * as React from 'react';
import Button from '@mui/material/Button';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';


export const EditButton = () => {
    const handleClick = () => {
    };

    return(
        <Button type="submit" variant="contained" startIcon={<TaskAltOutlinedIcon />} sx={{
            background: " var(--Light-Verde---light, #88C54B)",
            width: "236px",
            height: "54px",
            padding: "15px 16px",
            borderRadius: "8px",
            fontFamily: 'Poppins, sans-serif',
            fontFize: '20px',
            fontWeight: 300,
            textTransform: 'none', 

            '&:hover': {
                backgroundColor: "#88C54B",
              },
              }}
              onClick={handleClick}
              >
        Editar beneficiário
      </Button>
    );
};


